/**
 * アプリケーションエントリーポイント
 *
 * @file main.tsx
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * Reactアプリケーションのメインエントリーポイント。ReactDOMでDOMへのレンダリング、
 * BrowserRouterでのURIルーティング、AuthProviderでの認証コンテキストを初期化。
 * 公開表示設定取得後に i18n 初期化（defaultLanguage 注入）し render する。
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import BuyerRoutes from './routes/BuyerRoutes';
import App from '@shared/App.tsx';
import { initializeI18n } from '@shared/i18n';
import { getPublicDisplaySettings } from '@/services/api/public-settings.service';
import { DisplaySettingsProvider } from '@/contexts/DisplaySettingsContext';
import { setDisplaySettingsSnapshot } from '@/contexts/displaySettingsSnapshot';
import '@shared/styles/common.css';
import '../public/css/buyer.css';
import 'material-icons/iconfont/material-icons.css';
import '@fontsource/noto-sans-jp/300.css';
import '@fontsource/noto-sans-jp/400.css';
import '@fontsource/noto-sans-jp/500.css';
import '@fontsource/noto-sans-jp/700.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

getPublicDisplaySettings().then((settings) => {
  setDisplaySettingsSnapshot(settings);
  return initializeI18n('buyer', settings.defaultLanguage).then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <DisplaySettingsProvider value={settings}>
          <BrowserRouter>
            <App role="buyer" notificationDurationSeconds={settings.notificationDefaultDurationSeconds}>
              <BuyerRoutes />
            </App>
          </BrowserRouter>
        </DisplaySettingsProvider>
      </React.StrictMode>,
    );
  });
}).catch((err: unknown) => {
  throw err;
});
